<template>
 <div class="products">
    <slider animation="fade" :control-btn="false">
      <!-- <slider-item><img src="@/assets/images/chuyingProduct.jpg" height="100%"></slider-item>
      <slider-item><img src="@/assets/images/yashiliProduct.jpg" height="100%"></slider-item> -->
      <slider-item><img src="@/assets/images/banner_tianbao1.jpg" height="100%"></slider-item>
    </slider>
    <div class="module tianbao">
      <h1 class="title">添葆，全家羊奶营养专家！</h1>
      <p class="subTitle">添葆，营养补充不盲目，全家营养不将就。</p>
      <div class="content bgFour">
        <div class="contentWidth clearfix rightImg">
            <!-- <img class="productLogo" src="@/assets/images/products_tianbao.jpg" width="860" /> -->
            <img class="brandLogo" src="@/assets/images/logo_tianbao.png" height="160" />
            <div class='detail fleft'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;添葆羊奶，致力于研究不同年龄阶段人体的营养诉求，提供不同的营养解决方案，让全家营养在线。添葆，用醇鲜羊奶、科学配方及专利技术实力结合，步步严苛要求，只为做专业好羊奶，打造专属全家人的羊奶营养佳品。旗下现有全家营养羊奶粉，纯羊奶粉、纯羊奶、中老年高钙益生菌配方羊奶粉等。<router-link to="productDetail" class="more fright">了解更多 >></router-link>
            </div>
        </div>
      </div>
      <div class="productImg">&nbsp;</div>
    </div>
    <div class="module">
      <h1 class="title">草木羊系列羊乳制品</h1>
      <p class="subTitle">草木羊，有态度，自然醇</p>
      <div class="content bgCaoMuYang">
        <div class="contentWidth clearfix leftImg">
            <!-- <img class="productLogo" src="@/assets/images/cmyP2.png" width="630" /> -->
            <img class="productLogo" src="@/assets/images/caomuyang_dig.png" width="470" />
            <img class="brandLogo caomuyang" src="@/assets/images/caomuyang_logo.png" width="248" />
            <div class='detail fright'>
              &nbsp;&nbsp;&nbsp;&nbsp;草木羊是西安羊羊村落乳业集团有限公司旗下的自然羊奶品牌，是专注于自然纯羊奶的羊奶品牌。努力的做着自然乳制品中的特斯拉，研发原生自然、新鲜的羊奶。草木羊，让喝羊奶成为习惯，让选羊奶回归简单。草木羊，有态度，自然醇！旗下现有草木羊纯羊奶、草木羊羊奶，儿童成长高钙高锌配方羊奶粉。
              <br /><b>品牌理念：</b>
              <br />将原生羊奶还原精致营养，将自然本真持续保留，做自然纯羊奶。
            </div>
        </div>
      </div>
    </div>
    <div class="module">
      <h1 class="title">御宝成人系列配方羊乳粉</h1>
      <p class="subTitle">专注只为专业羊奶</p>
      <div class="content bgfive">
        <div class="contentWidth clearfix rightImg">
             <img class="productLogo" src="@/assets/images/yubaozhen_png.png" width="470" />
             <img class="brandLogo" src="@/assets/images/yubao_logo.png"/>
             <div class='detail fleft'>
               &nbsp;&nbsp;&nbsp;&nbsp; 御宝主品牌系列产品，产品线覆盖各类受众人群（儿童、学生、女士/孕妇、青年、中老年），涵盖面广！
               <br/>
               &nbsp;&nbsp;&nbsp;&nbsp;御宝成人系列配方羊乳粉，经国检|行检|自检3重质检品质安全！奶源源自于八百里秦川天然牧场，2-4℃ 2h冷链运输至厂，生产商西安百跃羊乳集团自建2.4万㎡羊奶粉样板工厂，引进德国、瑞士等国外生产工艺及机器。建立约1500㎡羊乳检测实验室，严苛质检，产品批批检验合格方可出厂！
             </div>
        </div>
      </div>
    </div>
     <div class="module">
      <h1 class="title">羊村添纯儿童配方羊奶粉</h1>
      <p class="subTitle">科学好营养，孩子健康成长</p>
      <div class="content bgThree">
        <div class="contentWidth clearfix leftImg">
             <img class="productLogo" src="@/assets/images/pic_tianchun.png" width="470" />
             <img class="brandLogo" src="@/assets/images/logo_tianchun.png"/>
             <div class='detail fright'>
               &nbsp;&nbsp;&nbsp;&nbsp; 添纯儿童配方羊奶粉，是一款针对3-7岁孩子进入幼儿园，并且开始更多种类学习的特殊阶段的羊奶粉。
               <br/>
               &nbsp;&nbsp;&nbsp;&nbsp;为了符合孩子这个阶段对体质、综合营养等多方面的需求，添纯定制科学配方，为孩子成长打下坚实基础，各方面均衡发展，做一个全勤宝宝。
             </div>
        </div>
      </div>
    </div>
 </div>
</template>

<script>
import { Slider, SliderItem } from 'vue-easy-slider'

export default {
  name: 'products',
  data () {
    return {}
  },
  components: {
    Slider,
    SliderItem
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.products{
  padding-bottom: 40px;
  .slider {
    width: 100% !important;
    height: 450px !important;
    min-width:1280px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .module{
    padding: 88px 0 45px 0;
    .title{
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      color:#333;
      background: url(../assets/images/line.png) bottom center no-repeat;
      padding-bottom: 22px;
    }
    .subTitle{
      text-align: center;
      font-size: 20px;
      color: #4d4d4d;
      padding:12px 0 200px 0;
    }
    .bgOne{
      background: url(../assets/images/jpg1.png) left 9px no-repeat;
      .brandLogo{ top:-120px;}
      .productLogo{ bottom:-33px;}
    }
    .bgTwo{
      background: url(../assets/images/jpg2.png) right 9px no-repeat;
      .brandLogo{ top:-120px;}
      .productLogo{  bottom:-26px;}

    }
    .bgThree{
      background: url(../assets/images/jpg3.png) left 9px no-repeat;
      .brandLogo{ top:-120px;}
      .productLogo{  bottom:-38px;}
    }

    .bgFour{
      width: 100%;
      // position: relative;
      // background: url(../assets/images/products_tianbao.jpg) right bottom no-repeat;
      .brandLogo{ top: -160px;}
      .productLogo{ bottom:0px; left: 480px !important;}
    }
    &.tianbao {
      position: relative;;
    }
    .productImg {
      background: url(../assets/images/products_tianbao.jpg) 100% 0px no-repeat;
      background-size: contain;
      position: absolute;
      z-index: 101;
      bottom: 50px;
      display: block;
      height: 430px;
      width: 100%;
    }
    .bgfive{
      background: url(../assets/images/jpg5.png) right bottom no-repeat;
      .brandLogo{ top: -142px; width:179px}
      .productLogo{ bottom:-6px; left: 623px !important;}
    }
    .contentWidth{
       position: relative;
       img{
         position: absolute;
       }
    }
    .leftImg{
      .brandLogo{
         right:414px;
      }
      .productLogo{
         right:630px;
      }
    }
    .rightImg {
      .brandLogo{left:313px;}
    }
    .bgFour{
      .brandLogo{ left: 430px;}
      .productLogo {
        left: 740px;
      }
    }
    .bgCaoMuYang {
      background: url('../assets/images/cmy_bg.jpg') left 9px bottom 0px no-repeat;
      .brandLogo { top: -120px; left: 544px; text-shadow: 1px 1px 5px rgba(0, 0, 0, .3)}
      .productLogo { position:absolute; bottom: -60px; right: 615px;}
      .productLogoCMY { position: absolute; top: -150px; right: 630px;}
    }
    .detail{
      min-height: 300px;
      width:582px;
      font-size: 16px;
      line-height: 40px;
      background-color: #fff;
      &.fleft{
        padding-right: 48px;
      }
      &.fright{
        padding-left: 48px;
      }
      .more{
        color: #03a9f4;
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/products.vue